<template>
  <div class="lang-switcher">
    <el-dropdown @command="handleCommand" trigger="click">
      <span class="el-dropdown-link">
        {{ currentLangLabel }}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="zh-CN">简体中文</el-dropdown-item>
        <el-dropdown-item command="zh-TW">繁體中文</el-dropdown-item>
        <el-dropdown-item command="en">English</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
/**
 * 语言切换组件
 * @component LangSwitcher
 */
export default {
  name: 'LangSwitcher',
  computed: {
    /**
     * 获取当前语言标签
     * @returns {string} 当前语言标签
     */
    currentLangLabel() {
      const langMap = {
        'en': 'English',
        'zh-CN': '简体中文',
        'zh-TW': '繁體中文'
        
      }
      return langMap[this.$i18n.locale] || '简体中文'
    }
  },
  methods: {
    /**
     * 处理语言切换命令
     * @param {string} command - 语言代码
     */
    handleCommand(command) {
      if (this.$i18n.locale !== command) {
        this.$i18n.locale = command
        localStorage.setItem('lang', command)
        // 刷新页面以应用新语言
        this.$router.go(0)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lang-switcher {
  margin-left: 15px;
  
  .el-dropdown-link {
    cursor: pointer;
    color: #333;
    font-size: 14px;
    
    &:hover {
      color: #ff6b00;
    }
  }
}
</style> 